var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.82994 5.29019L2.58994 1.05019C2.40218 0.86088 2.14658 0.754395 1.87994 0.754395C1.61331 0.754395 1.35771 0.86088 1.16994 1.05019C0.782219 1.44023 0.782219 2.07016 1.16994 2.46019L4.70994 6.00019L1.16994 9.54019C0.782219 9.93023 0.782219 10.5602 1.16994 10.9502C1.35866 11.1374 1.61414 11.2417 1.87994 11.2402C2.14575 11.2417 2.40122 11.1374 2.58994 10.9502L6.82994 6.71019C7.01926 6.52243 7.12574 6.26683 7.12574 6.00019C7.12574 5.73356 7.01926 5.47796 6.82994 5.29019Z","fill":"#ADB0BA"}));
}

RightArrow.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
